import { render, staticRenderFns } from "./FalsePositive.vue?vue&type=template&id=006c2a73&"
import script from "./FalsePositive.vue?vue&type=script&lang=js&"
export * from "./FalsePositive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports